<template>
  <div id="app-nav">
    <div class="nav-box">
      <ul>
        <li
          v-for="(item,index) in channelList"
          :key="index"
          @click="getStyle(item)"
          @mouseenter="navBarShow(item)"
          @mouseleave="navHidden"
          :class="{active:checkId==item.id}"
        >
          <span></span>
          <i>{{item.channel_title}}</i>
          <div class="p-box" v-show="childShow&&childId==item.id">
            <p v-for="(item1,index1) in item.children" :key="index1" @click="goto(item1)" v-show="item1.parent_id > 0 ">
              <i></i>
              <span>{{item1.channel_title}}</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      channelList: [],
      newPath: {}, //组装的路由路径
      checkId: 1,
      childShow: false,
      childId: -1
    };
  },
  methods: {
    getStyle(item) {
      //点击一级导航

      this.checkId = item.id;

      let index = item.cat_type;
      if (index == 4) {
        //新窗口打开外部链接
        window.open(item.channel_url);
      } else {
        sessionStorage.setItem('breadOne',item.channel_title)
        this.$router.push(this.newPath);
      }
    },
    navBarShow(item) {
      //鼠标移至一级导航
      let index = item.cat_type;
      let type = item.template;

      // if(item.cat_type == 1|| item.cat_type == 3){//只有一级导航为列表才显示二级导航
      //   this.childShow = true
      // }else{
      //   this.childShow = false
      // }

      if (index != 4) {
        //除外部链接
        if (index == 5) {
          //内部链接
          if (type == 1) {
            //首页
            delete this.newPath.query;
            this.newPath.path = "/";
          } else if (type == 5) {
            //救助申请
            this.newPath.path = "/applyIndex";
          } else if (type == 6) {
            this.newPath.path = "/branchIndex";
          } else {
            //组装路由地址
            this.newPath.query = {};
            this.newPath.path = "/pubIndex";
            this.newPath.query.cid = item.id;
          }
        } else {
          //组装路由地址
          this.newPath.query = {};
          this.newPath.path = "/pubIndex";
          this.newPath.query.cid = item.id;
        }
      }

      this.childId = item.id;
    },

    goto(item) {
      //点击二级导航
      if (item.cat_type == 4) {
        window.open(item.channel_url);
      } else {
        this.newPath.query.tabid = item.id;
        this.$router.push(this.newPath);
      }
    },
    navHidden() {
      this.childShow = true;
      this.childId = -1;
    },

    //获取导航列表
    getChannelList() {
      this.$db.post(this.$db.config.getChannelDataUrl, {}).then(res => {
        if (res.code == 200) {
          this.channelList = res.data;
          let info = JSON.stringify(res.data);
          sessionStorage.setItem("channelPcList", info);
        }
      });
    }
  },
  watch: {
    "$route.query.cid": function(val) {
      this.checkId = val;
    }
  },
  created() {
    window.addEventListener("beforeunload", e => {
      sessionStorage.removeItem("channelPcList");
    });
    if (sessionStorage.getItem("channelPcList")) {
      this.channelList = JSON.parse(sessionStorage.getItem("channelPcList"));
    } else {
      this.getChannelList();
    }

    this.checkId = this.$route.query.cid ? this.$route.query.cid : 1;
  }
};
</script>

<style lang="scss" scoped>
#app-nav {
  width: 100%;
  background-color: #fff;
  height: 65px;
  background-color: #c30d23;
}
.nav-box {
  width: 1300px;
  margin: 0 auto;
  position: relative;
  > ul {
    display: flex;
    justify-content: space-between;
    > li {
      font-size: 18px;
      color: #fff;
      list-style: none;
      line-height: 65px;
      padding: 0 36px;
      cursor: pointer;
      position: relative;
      > i {
        font-style: normal;
        position: relative;
      }
      &:hover {
        > span {
          &::before {
            height: 100%;
          }
        }
      }
      > span {
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 0;
          background-color: #a7091c;
          transition: all 0.4s ease;
        }
      }

      .p-box {
        z-index: 9999;
        position: absolute;
        top: 65px;
        left: 0;
        width: 100%;
        text-align: center;
        background-color: rgba($color: #a7091c, $alpha: 0.55);
        transition: all 0.4s ease;
        // height: 0;
        > p {
          color: #fff;
          line-height: 55px;
          transition: all 0.8s ease;
          position: relative;
          width: 100%;

          &:hover {
            > i {
              &::before {
                width: 100%;
              }
            }
          }
          > span {
            display: block;
            color: #fff;
            position: relative;
            width: 100%;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > i {
            &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              width: 0;
              height: 100%;
              background-color: rgba(167, 9, 28, 0.5);
              transition: all 0.4s ease;
            }
          }
        }
      }
    }
    li.active {
      background-color: #a7091c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/nav.vue